import * as pbFunc from "@/assets/utils";
import classify from "@/pages/automaticStation/classify" //自动站列表

import system from "@/pages/automaticStation/classify/system" //设备详情

const list = [{
  path: "classify/:id",
  name: "classify",
  meta: {
    title: "自动站列表",
    requireAuth: true
  },
  component: classify,
}, {
  path: "classifySystem/:type/:stationId/:id",
  name: "system",
  meta: {
    title: "设备详情",
    requireAuth: true
  },
  // type: 'HpicData',
  component: system,
}]
// let stationListRouter = []; //自动站列表路由
// let token = pbFunc.getLocalData('token', true);
// console.log('token', token)
// if (token) {
//   stationListRouter.push(list[0]);
//   let stationList = pbFunc.getLocalData('station', true);
//   for(let i in stationList){
//     for(let j in stationList[i]){
//       for(let z in list){

//       }
//     }
//   }
// }
export default list;



// WEBPACK FOOTER //
// ./src/router/automaticStation.js